import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';
import { useState } from 'react';

export default function CategorySection() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const displayedCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="py-14 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            漫画分类
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            多种类型任您选择，找到您最爱的<strong>韩国漫画</strong>
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {displayedCategories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="relative group cursor-pointer"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className={`
                flex flex-col items-center justify-center gap-2 p-5 md:p-6 rounded-xl
                transition-all duration-300 border
                ${hoveredIndex === index
                  ? 'bg-accent-100/80 border-accent-300 scale-105'
                  : 'bg-background-100 border-background-200/60'
                }
              `}>
                <div className={`
                  w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center transition-all duration-300
                  ${hoveredIndex === index
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                  }
                `}>
                  <i className={`text-xl ${
                    cat.slug === 'romance' ? 'ri-heart-line' :
                    cat.slug === 'fantasy' ? 'ri-magic-line' :
                    cat.slug === 'action' ? 'ri-sword-line' :
                    cat.slug === 'comedy' ? 'ri-emotion-laugh-line' :
                    cat.slug === 'thriller' ? 'ri-search-eye-line' :
                    cat.slug === 'slice-of-life' ? 'ri-sun-line' :
                    cat.slug === 'drama' ? 'ri-clapperboard-line' :
                    cat.slug === 'horror' ? 'ri-ghost-line' :
                    cat.slug === 'bl' ? 'ri-hearts-line' : 'ri-book-read-line'
                  }`}></i>
                </div>
                <span className={`text-sm font-medium whitespace-nowrap transition-colors duration-300 ${
                  hoveredIndex === index ? 'text-accent-800' : 'text-foreground-700'
                }`}>
                  {cat.name}
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer transition-colors"
          >
            查看全部漫画 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}